import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { GET_PROFILE_PERCENTAGE, POST_LOGIN } from "./../utils/api";
import { useDispatch, useSelector } from "react-redux";
import { PROFILE_COMPLETION_SUCCESS } from "../Redux/profile/profile.actionTypes";
import ToastMessage from "../utils/toasts/toastMessage";
import Loader from "../utils/loader/loader";
import { apiRequest } from "../api/apiRequest";
const Login = () => {
  const nav = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [toastState, setToastState] = useState({
    show: false,
    message: "",
    type: "",
  });
  const [input, setInput] = useState({
    email: "",
    password: "",
  });

  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleFormsInputs = (e) => {
    setInput((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const fetchProfileAndRedirect = async (token, roleId) => {
  try {
    const profileResp = await axios.get(GET_PROFILE_PERCENTAGE, {
      headers: { Authorization: `Bearer ${token}` },
      withCredentials: true,
    });

    const completion = profileResp.data?.profile_completion || 0;

    dispatch({
      type: PROFILE_COMPLETION_SUCCESS,
      payload: profileResp.data,
    });
    setTimeout(()=>{
        if (roleId === 1 || roleId === "1") {
      nav(completion > 70 ? "/dashboard-page" : "/userprofile", {
        replace: true,
      });
    } else if (roleId === 2 || roleId === "2") {
      nav(completion > 70 ? "/teacher" : "/teacher-profile", {
        replace: true,
      });
    } else if (roleId === 3 || roleId === "3") {
      nav("/people", { replace: true });
    }

    },500)
  
  } catch (error) {
    console.error(error);
  }
};

useEffect(() => {
  const token = localStorage.getItem("access_token");
  const role = localStorage.getItem("role");

  if (token && role) {
    fetchProfileAndRedirect(token, role);
  }
}, []);

// const handleLogin = async () => {
//   if (!input.email || !input.password) {
//     setToastState({
//       show: true,
//       message: "Email and password are required!",
//       type: "error",
//     });
//     return;
//   }

//   setLoading(true);

//   try {
//     const payload = {
//       email: input.email,
//       password: input.password,
//     };

//     const resp = await axios.post(POST_LOGIN, payload, {
//       headers: { "Content-Type": "application/json" },
//     });

//     if (resp.status !== 200) {
//       throw new Error("Invalid credentials");
//     }

//     const token = resp.data?.access_token;
//     const roleId = resp.data?.role_id;
//     const firstLogin = resp.data?.first_login;
//     const is_admin_created = resp.data?.is_admin_created;

//     localStorage.setItem("access_token", token);
//     localStorage.setItem("role", roleId);

//     if (firstLogin && roleId !== 3 && is_admin_created === true) {
//       nav("/change-password", { replace: true });
//       return;
//     }

//     await fetchProfileAndRedirect(token, roleId);

//   } catch (err) {
//     setToastState({
//       show: true,
//       message: err?.response?.data?.detail || "Please signup first!",
//       type: "error",
//     });
//   } finally {
//     setLoading(false);
//   }
// };

const handleLogin = async () => {
  if (!input.email || !input.password) {
    setToastState({
      show: true,
      message: "Email and password are required!",
      type: "error",
    });
    return;
  }

  setLoading(true);

  const payload = {
    email: input.email,
    password: input.password,
  };

  // NOTE: On invalid credentials this request commonly returns a 401.
  // apiClient's global response interceptor auto-clears the token and
  // redirects to "/login" on any 401 (unless already on that pathname).
  // Make sure your login page route is exactly "/login" — otherwise a
  // failed login will force-navigate away before this toast can render.
  const result = await apiRequest("post", POST_LOGIN, payload);

  if (!result.success) {
    setToastState({
      show: true,
      message: result.message || "Please signup first!",
      type: "error",
    });
    setLoading(false);
    return;
  }

  const token = result.data?.access_token;
  const roleId = result.data?.role_id;
  const firstLogin = result.data?.first_login;
  const is_admin_created = result.data?.is_admin_created;

  localStorage.setItem("access_token", token);
  localStorage.setItem("role", roleId);

  if (firstLogin && roleId !== 3 && is_admin_created === true) {
    setLoading(false);
    nav("/change-password", { replace: true });
    return;
  }

  await fetchProfileAndRedirect(token, roleId);
  setLoading(false);
};

  return (
    <section className="auth-main">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="w-100 auth-content">
              <div className="pt-4 auth-content__graphics">
                <img
                  src="./assets/images/inner-pages/auth-side-image.png"
                  alt=""
                  className="main-img"
                />
                <img
                  src="./assets/images/inner-pages/auth-side-prop01.png"
                  alt=""
                  className="anim-up-down side-prop side-prop01"
                />
                <img
                  src="./assets/images/inner-pages/auth-side-prop02.png"
                  alt=""
                  className="anim-up-down side-prop side-prop02"
                />
                <img
                  src="./assets/images/inner-pages/auth-side-shield03.png"
                  alt=""
                  className="anim-up-down side-prop side-prop03"
                />
              </div>
              <img
                src="./assets/images/JigyaasuBlackLogo.svg"
                alt=""
                className="logo-img"
              />
              <div className="auth-content__right">
                <div className="ff-poppins curved-block curved-block--login">
                  <div className="top-white"></div>
                  <form
                    onSubmit={(e) => {
                      e.preventDefault();
                      handleLogin();
                    }}
                  >
                    <div className="middle-white">
                      <h1 className="fw700 fz56 primaryText">
                        Login to your account
                      </h1>
                      <p className="fz20">
                        {/* Create your account it take than a minute */}
                      </p>

                      <div className="middle-white__inner">
                        <div className="form-group">
                          <label htmlFor="email" className="fw500 fz16 label">
                            Email
                          </label>
                          <input
                            type="email"
                            className="fz16 form-control"
                            name="email"
                            onChange={handleFormsInputs}
                          />
                        </div>
                        <div
                          className="form-group"
                          style={{ position: "relative" }}
                        >
                          <label htmlFor="Otp" className="fw500 fz16 label">
                            Password
                          </label>
                          <input
                            // type="password"
                            type={showPassword ? "text" : "password"}
                            className="fz16 form-control"
                            name="password"
                            onChange={handleFormsInputs}
                          />
                          <i
                            className={`fa ${
                              showPassword ? "fa-eye" : "fa-eye-slash"
                            }`}
                            onClick={togglePasswordVisibility}
                            style={{
                              cursor: "pointer",
                              position: "absolute",
                              right: "10px",
                              top: "65%",
                              transform: "translateY(-50%)",
                            }}
                          ></i>
                        </div>
                        <div className="remember-forgot">
                          {/* <div className="ps-0 fz500 grayText fz16 m-0 checkbox-container">
                            <input
                              id="remember"
                              type="checkbox"
                              name="remember"
                              className="lang-input"
                            />
                            <label htmlFor="remember">
                              <b />
                              Remember me
                            </label>
                          </div> */}

                          <Link to="/forgot-password" className="fz16 grayText">
                            {" "}
                            Forgot Password?
                          </Link>
                          {/* <a href="#" className="fz16 grayText">
                            Forgot Password?
                          </a> */}
                        </div>
                      </div>
                    </div>
                    <div className="bottom-white">
                      <div className="bottom-white__left">
                        <div className="fw500 grayText title-row">
                          Or Sign in with
                        </div>
                        <ul className="list-inline m-0 social-icons">
                          <li>
                            <a
                              href="https://api.jigyaasu.ai/api/auth/google/login"
                              className=""
                            >
                              <img
                                src="./assets/images/inner-pages/icons/icon-google.svg"
                                alt=""
                              />
                            </a>
                          </li>
                          {/* <li>
                          <a href="#" className="">
                            <img
                              src="./assets/images/inner-pages/icons/icon-fb.svg"
                              alt=""
                            />
                          </a>
                        </li>
                        <li>
                          <a href="#" className="">
                            <img
                              src="./assets/images/inner-pages/icons/icon-insta.svg"
                              alt=""
                            />
                          </a>
                        </li> */}
                        </ul>
                      </div>
                      <div className="bottom-white__right">
                        <button
                          type="submit"
                          className="btn btn-solid btn-solid--dark btn-auth"
                        >
                          <span className="fw500">Login</span>
                        </button>
                      </div>
                    </div>
                  </form>
                  <p className="outer-statement">
                    Not Registered yet?{" "}
                    <a
                      href="javascript:void(0)"
                      className="fw500"
                      onClick={() => nav("/signup")}
                    >
                      Create an account
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Loader show={loading} />
      <ToastMessage
        show={toastState.show}
        onClose={() => setToastState({ show: false, message: "", type: "" })}
        message={toastState.message}
        type={toastState.type}
      />
    </section>
  );
};

export default Login;
